/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Homeworks</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th>S/N</th>
                        <th scope="col">Title</th>
                        <th scope="col">Max</th>
                        <th scope="col">Min</th>
                        <th scope="col">Rows</th>
                        <th scope="col">Steps</th>
                        <th scope="col">Group</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(lesson, index) in lessons" :key="lesson._id">
                        <th>{{index + 1}}</th>
                        <th>{{lesson.title}}</th>
                        <th>{{lesson.max}}</th>
                        <td>{{lesson.min}}</td>
                        <td>{{lesson.cols}}</td>
                        <td>{{lesson.step}}</td>
                        <td>{{lesson.group}}</td>

                        <td>
                            <button class="btn btn-primary btn-sm" @click="editLesson(lesson._id, index)">Edit</button>
                            <mdb-container>
                                <!-- trigger modal button -->

                                <!-- cookie modal -->
                                <mdb-modal size="lg" :show="modalEditLesson == lesson._id" removeBackdrop centered scrollable>
                                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="modalEditLesson = false">Close</button>
                                    <mdb-modal-body>
                                        <div class="card z-depth-5 p-3">
                                            <h4 class="text-center font-weight-bold py-3">Edit Homework</h4>
                                            <div>
                                                <!-- Default form login -->
                                                <form class="border border-light p-5">
                                                    <div class="row">
                                                        <div class="form-group col-md-12">
                                                            <label>Homework Title</label>
                                                            <input type="text" v-model="title" class="form-control mb-4" placeholder="Homework Title">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Minimum</label>
                                                            <input type="number" v-model="min" class="form-control mb-4" placeholder="Min">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Maximum</label>
                                                            <input type="number" v-model="max" id="" class="form-control mb-4" placeholder="Max">
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label>Rows</label>
                                                            <input type="number" v-model="cols" class="form-control mb-4" placeholder="Rows">
                                                        </div>
                                                        <div class=" form-group col-md-4 ">
                                                            <label>Step</label>
                                                            <input type="number" v-model="step" class="form-control mb-4" placeholder="Step">
                                                        </div>
                                                        <div class=" form-group col-md-4">
                                                            <label>Group</label>
                                                            <input type="number" v-model="group" class="form-control mb-4" placeholder="Group">
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Disable This Homework ?</label>
                                                            <select v-model="disabled" class="form-control form-control-sm mb-4">
                                                                <option value="true">YES</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label>Decimal</label>
                                                            <select v-model="decimal" class="form-control form-control-sm mb-4">
                                                                <option value="true">YES</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                        </div>

                    <div class="col-md-12">
                        <div class=" form-group">
                            <label>Select Operations (Multiple Operators can be selected)</label>
                            <select v-model="operations" class="form-control" multiple>
                                <option value="+">Addition (+)</option>
                                <option value="-">Subtraction (-)</option>
                                <option value="/">Division (/)</option>
                                <option value="*">Multiplication (*)</option>
                            </select>
                            
                        </div>
                        <div class="divider2-color white-text mt-2 p-2" v-if="operations.length > 0">
                            Selected Operators : {{operations}}
                        </div>
                    </div>

                                                        

                                                        <div class="form-group col-12 mt-2">
                                                            <div class="divider2">
                                                                <h5 class="font-weight-bold ">Add Homework</h5>
                                                            </div>
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <div class="form-group ">
                                                                <label>Day</label>
                                                                <select v-model="homeDay" class="form-control form-control-sm mb-4">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="6">6</option>
                                                                </select>
                                                            </div>
                                                            <div class="form-group">
                                                                <label>Value</label>
                                                                <input type="number" v-model="homeValue" id="" class="form-control form-control-sm mb-4" placeholder="Value">
                                                            </div>
                                                            <div class="form-group ">
                                                                <label>Type</label>
                                                                <select v-model="homeType" class="form-control form-control-sm mb-4">
                                                                    <option value="a">Audio</option>
                                                                    <option value="s">Static</option>
                                                                    <option value="f">Flash</option>
                                                                </select>
                                                            </div>
                                                            <div class="form-group">
                                                                <button class="btn btn-black  btn-block mt-4" @click.prevent="addHomework()">Add Homework</button>
                                                            </div>
                                                        </div>
                                                        <div class="form-group col-md-6 divider2-color white-text pt-3">
                                                            <h6 class="font-weight-bold">Added Homeworks</h6>
                                                            <div class="table-responsive">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr class="white-text text-muted">
                                                                        <th scope="col">Day</th>
                                                                        <th scope="col">Value</th>
                                                                        <th scope="col">Type</th>
                                                                        <th scope="col">Remove</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr class="white-text text-muted" v-for="(homework, index) in homeworks" :key="index">
                                                                        <td>{{homework.day}}</td>
                                                                        <td>{{homework.value}}</td>
                                                                        <td>{{homework.type}}</td>
                                                                        <td>
                                                                            <span class="btn btn-danger btn-sm" @click.prevent="removeTask('homeworks',index)">Remove</span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            </div>
                                                        </div>





<div class="form-group col-12 pt-3 ">
                        <div class="divider1">
                            <h5 class="font-weight-bold">Formulae</h5>
                        </div>

            </div>
                    <div class="form-group col-md-6">
                       <div class="row">
                         <div class="form-group col-md-6">
                            <label>Central</label>
                            <input type="number" v-model="formulaCentral"  class="form-control form-control-sm mb-4" placeholder="Value">
                        </div>
                        <div class="form-group col-md-6">
                            <label>Focus</label>
                            <input type="number" v-model="formulaFocus"  class="form-control form-control-sm mb-4" placeholder="Value">
                        </div>
                       </div>
                        <div class="form-group ">
                            <label>Category</label>
                            <select v-model="formulaCategory" class="form-control form-control-sm mb-4">
                                <option value="little friend">Little Friend</option>
                                <option value="big friend">Big Friend</option>
                                <option value="grand family">Grand Family</option>
                                <option value="multiplication">Multiplication</option>
                                <option value="division">Division</option>
                                <option value="random">Random</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-black btn-block mt-4" @click.prevent="addFormula()">Add Formula</button>
                        </div>
                    </div>
                    <div class="form-group col-md-6 divider1-color white-text">
                        <div class="form-group col-12">
                            <h6 class="font-weight-bold pt-3">Added Formulae</h6>
                            <div class="table-responsive">
                                <table class="table">
                                <thead>
                                    <tr class="white-text text-muted">
                                         <th scope="col">Category</th>
                                        <th scope="col">Central</th>
                                        <th scope="col">Focus</th>
                                        
                                        <th scope="col">Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="white-text text-muted" v-for="(formula, index) in formulae" :key="index">
                                        <td>{{formula.category}}</td>
                                        <td>{{formula.central}}</td>
                                        <td>{{formula.focus}}</td>
                                         
                                        <td>
                                            <button class="btn btn-danger btn-sm" @click.prevent="removeTask('formulae',index)">Remove</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>


                                                    </div>

                                                    <!-- Sign in button -->
                                                    <button class="btn btn-info btn-block my-4" @click.prevent="addLesson(lesson._id)">Update Lesson</button>

                                                </form>
                                                <!-- Default form login -->
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="modalEditLesson = false">Close</button>

                                        </div>
                                    </mdb-modal-body>
                                </mdb-modal>
                            </mdb-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<style scoped>
.divider1 {
    padding: 10px;
    background: #1C2331;
    width: 80%;
    color: #fff;
}

.divider1-color {

    background: #1C2331;

}

.divider2 {
    padding: 10px;
    background: #344C6E;
    width: 80%;
    color: #fff;
}

.divider2-color {
    background: #344C6E;
}
</style>

<script>
import axios from "axios"
import {
    mdbContainer,
    mdbModal,
    mdbModalBody
} from 'mdbvue';
export default {
    name: 'Homeworks',
    components: {
        mdbContainer,
        mdbModal,
        mdbModalBody,
    },
    data() {
        return {
            lessons: [],
            levelId: this.$route.params.levelId,
            modalEditLesson: false,
            lessonId: '',
            homeworks: [],
            classworks: [],
            operations : [],
            formulae: [],
            lessonIndex: '',
            max: '',
            title: '',
            assValue: '',
            homeValue: '',
            homeDay: '',
            formulaCentral : '',
            formulaCategory: '',
            formulaFocus:'',
            assType: '',
            homeType: '',
            min: '',
            cols: '',
            step: '',
            group: '',
            disabled: false,
            decimal: false,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        editLesson(lessonId, index) {
            this.homeworks = [];
            this.classworks = [];
            this.formulae = [];
            this.lessonId = lessonId;
            this.lessonIndex = index;
            this.modalEditLesson = this.lessonId
            for (var i = 0; i < this.lessons.length; i++) {
                if (i == this.lessonIndex) {
                    var homeworkArray = this.lessons[i].homework
                    this.homeworks = homeworkArray.concat(this.homeworks);

                    var classworkArray = this.lessons[i].classwork
                    this.classworks = classworkArray.concat(this.classworks);

                    var formulaeArray = this.lessons[i].formulae
                    this.formulae = formulaeArray.concat(this.formulae);
                    
                    this.title = this.lessons[i].title
                    this.max = this.lessons[i].max
                    this.min = this.lessons[i].min
                    this.cols = this.lessons[i].cols
                    this.step = this.lessons[i].step
                    this.group = this.lessons[i].group
                    this.disabled = this.lessons[i].disabled
                    this.decimal = this.lessons[i].isDecimal
                    this.operations = this.lessons[i].operations

                }
            }
        },


        addFormula() {
            if ((this.formulaCentral == "" || this.formulaFocus == "" || this.formulaCategory == "") && this.formulaCategory != "random") {
                this.$toast.open({
                    message: "Formula Central, Focus and Category are required",
                    type: 'error',
                    // all of other options may go here
                });
            } else {
                let newFormula = {
                    'category': this.formulaCategory,
                    'central': this.formulaCentral != "" ? parseInt(this.formulaCentral) : 0,
                    'focus': this.formulaFocus != "" ? parseInt(this.formulaFocus):  0
                    
                }
                this.formulae.push(newFormula);
                // eslint-disable-next-line no-console
                // console.log(this.classworks)
                this.$toast.open({
                    message: "New Formula Added",
                    type: 'info',
                    // all of other options may go here
                });
            }
        },


        addHomework() {
            if (this.homeValue == "" || this.homeType == "" || this.homeDay == "") {
                this.$toast.open({
                    message: "Homework Day, Type and Value are required",
                    type: 'error',
                    // all of other options may go here
                });
            } else {
                let newHomework = {
                    'day': parseInt(this.homeDay),
                    'value': parseInt(this.homeValue),
                    'type': this.homeType,
                }
                this.homeworks.push(newHomework);
                // eslint-disable-next-line no-console
                // console.log(this.homeworks)
                this.$toast.open({
                    message: "New Homework Added",
                    type: 'info',
                    // all of other options may go here
                });
            }
        },
        removeTask(taskName, index) {
            if (taskName == 'homeworks') {
                this.homeworks.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });
            }

            if (taskName == 'classworks') {
                this.classworks.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });
            }

            if (taskName == 'formulae') {
                this.formulae.pop(index)
                this.$toast.open({
                    message: "Removed",
                    type: 'info',
                    // all of other options may go here
                });
            }

        },
        addLesson(lesson_id) {
            let data = {
                title : this.title,
                min: parseInt(this.min),
                max: parseInt(this.max),
                cols: parseInt(this.cols),
                operations: this.operations,
                formulae : this.formulae,
                classwork: this.classworks,
                homework: this.homeworks,
                step: parseInt(this.step),
                group: parseInt(this.group),
                disabled: this.disabled,
                isDecimal: this.decimal
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }

            this.$toast.open({
                message: "Processing : Updating Lesson Please Wait...",
                type: 'info'
            })

            axios.post(this.$apiURI + "/levels/" + this.levelId + "/lessons/" + lesson_id + "/update", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Lesson Updated Successfully",
                            type: 'success'
                        })
                        this.modalEditLesson = false
                        setTimeout( window.location.reload(), 1000)
                       
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },

    mounted() {
        this.$toast.open({
            message: "Processing : Loading Lessons Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/levels/" + this.levelId + "/lessons", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    

                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.lessons)
                    let lessonData = response.data.data.lessons
                    Object.keys(lessonData).forEach(key => {

                        let keyLength = lessonData[key].length;
                        var i;
                        for (i = 0; i < keyLength; i++) {
                            // eslint-disable-next-line no-console
                            // console.log(lessonData[key][i]);
                            this.lessons.push(lessonData[key][i])
                        }

                    });

                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
